import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { LinkRoot } from "./link.styles.js";
const Link = forwardRef(function Link2(inProps, ref) {
  const { variant = "body1", eventId, ...props } = inProps;
  return /* @__PURE__ */ jsx(LinkRoot, { ...props, ref, variant, "data-eventid": eventId });
});
export {
  Link
};
//# sourceMappingURL=link.component.js.map
